import React, { useState } from "react";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field, Form } from "formik";
import * as Yup from "yup";
import { Link, useHistory } from "react-router-dom";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { MdOutlinePictureAsPdf, MdPictureAsPdf } from "react-icons/md";
import jsPDF from "jspdf";
import { FaFastBackward } from "react-icons/fa";

const VariationInCalculation = () => {
  const [HraFlag, setHraflag] = useState(false);
  const [categoryValue, setCategoryValue] = useState();
  const [Districtvalue, setDistrictValue] = useState();
  const [MonthValue, setMonthValue] = useState();
  const [DistplayMonth, setDistplayMonth] = useState();
  const [DisplayDistrict, setDisplayDistrict] = useState();
  const [DisplayYear, setDisplayYear] = useState();
  const [Yearvalue, setYearValue] = useState();
  const [monthlist, setmonthlist] = useState();
  const [yearlist, setyearlist] = useState();
  const [distList, setDistList] = useState();
  const [distData, setDistData] = useState([]);
  const [tableData, setTableData] = useState();
  const [tableDataFlag, setTableDatFlag] = useState(false);

  const history = useHistory();
  React.useEffect(() => {
    HousingService.fetchMonthList().then((res) => {
      if (res.data) {
        setMonthValue(res.data);
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.month_id}>
              {item.month_name}
            </option>
          );
        });
        setmonthlist(options);
      }
    });
    HousingService.fetchYearList().then((res) => {
      if (res.data) {
        setYearValue(res.data);
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.year}>
              {item.year}
            </option>
          );
        });
        setyearlist(options);
      }
    });
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        setDistrictValue(res.data);
        setDistData(res.data);
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.code}>
              {item.name}
            </option>
          );
        });
        setDistList(options);
      }
    });
  }, []);
  const handlePdf = (emp_id, payment_type, year, confirm_month) => {
    const values = {
      emp_id: emp_id,
      payment_type: payment_type,
      year: year,
      confirm_month: confirm_month
    };
    HousingService.emp_pay_particulars_pdf(values).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );

      let tab = window.open();

      tab.location.href = url;
    });
  };
  const validationSchema = Yup.object({
    category: Yup.string().required(),
    year: Yup.string().required(),
    confirm_month: Yup.string().required(),
    district: Yup.string().required(),
    hra_percent: Yup.string().when("category", {
      is: "HRA",
      then: Yup.string().required(
        "HRA Percent is required when category is HRA"
      ),
      otherwise: Yup.string()
    })
  });

  const formik = useFormik({
    initialValues: {
      category: "",
      confirm_month: "",
      year: "",
      district: "all",
      hra_percent: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let displaymonth = MonthValue.filter(
        (item) => item.month_id === values.confirm_month
      ).map((item) => item.month_name);
      setDistplayMonth(displaymonth);
      let displaydistrict = Districtvalue.filter(
        (item) => item.code == values.district
      ).map((item) => item.name);
      if (values.district == "all") {
        setDisplayDistrict("State");
      } else {
        setDisplayDistrict(displaydistrict);
      }

      let displayyear = Yearvalue.filter(
        (item) => item.year === values.year
      ).map((item) => item.year);

      setDisplayYear(displayyear);
      let params = {
        category: values.category,
        hra_percent: values.hra_percent,
        confirm_month: values.confirm_month,
        year: values.year,
        district: values.district
      };
      HousingService.VariationCalPaybill(params).then((res) => {
        setTableData(res.data);
        setTableDatFlag(true);
      }, []);
    }
  });
  const hraChange = (e) => {
    setCategoryValue(e.target.value);
    if (e.target.value === "HRA") {
      setHraflag(true);
    } else {
      setHraflag(false);
    }
  };

  function GeneratePDF() {
    const pageWidth = 210;
    const pageHeight = 297;
    const imgPath = "/img/APSHCL_logo.png";
    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [pageWidth, pageHeight] }); const YearNamee = DisplayYear; const MonthNamee = DistplayMonth;
    const headingText2 = "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText3 = `${DisplayDistrict}:Difference between the Calculated- ${categoryValue}-Basic Pay and ${categoryValue}    -Paid for the ${DistplayMonth} of ${DisplayYear} ${MonthNamee} ${YearNamee}`; // New heading text (displayed second)
    const headingText4 = "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007"; const fontSize = 12;
    const textWidth4 = (doc.getStringUnitWidth(headingText4) * fontSize) / doc.internal.scaleFactor; const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2; doc.setFont("times new roman");
    const textWidth2 = (doc.getStringUnitWidth(headingText2) * fontSize) / doc.internal.scaleFactor;
    const textWidth3 = (doc.getStringUnitWidth(headingText3) * fontSize) / doc.internal.scaleFactor; const tableYStart = 35;
    doc.setFontSize(fontSize); const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2; doc.text(headingText2, xCoordinate2, 10); const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2; doc.text(headingText3, xCoordinate3, 30); doc.text(headingText4, xCoordinate4, 20);
    doc.addImage(imgPath, "PNG", 5, 5, 25, 25); doc.autoTable({ html: "#my-table", theme: "grid", tableWidth: "auto", columnStyles: { 3: { cellWidth: "wrap" } }, startY: tableYStart, margin: { top: 5, right: 15, bottom: 5, left: 15 }, styles: { fontSize: 8 }, columnWidth: { 0: 20, 1: 30, 2: 40 } });
    doc.save("Report.pdf");
  }

  return (
    <>
      <NavigationServicesHeader />

      <OFMSUI.Container>
        <OFMSUI.Row>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}> VARIATION IN CALCULATION OF PAYBILL </h1> </div> </OFMSUI.Col> <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <button className="btn btn-primary btn-sm" style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="reset" onClick={() => history.goBack()} > <FaFastBackward /> &nbsp;Back </button> </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>

      <OFMSUI.Container className="outer-page-content-container fluid">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row className="p-3">
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" > <label> <b>Category</b> </label> <span className="mandatory" style={{ color: "red" }}> * </span> <Field component="select" name="category" className={ formik.touched.category && formik.errors.category ? "form-control is-invalid" : "form-control" } onChange={(e) => { hraChange(e); formik.handleChange(e); }} > <option value="">Select</option> <option value="DA">DA</option> <option value="HRA">HRA</option> <option value="IR">IR</option> <option value="EPF">EPF</option> </Field> </OFMSUI.Col> {HraFlag && ( <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" > <label> <b>HRA %</b> </label> <span className="mandatory" style={{ color: "red" }}> * </span> <Field component="select" name="hra_percent" className={ formik.touched.hra_percent && formik.errors.hra_percent ? "form-control is-invalid" : "form-control" } > <option value="">Select</option> <option value="30.00">30.00</option> <option value="20.00">20.00</option> <option value="12.50">12.50</option> </Field> </OFMSUI.Col>
              )}
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" > <label> <b> Month</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span> <Field component="select" name="confirm_month" onChange={(e) => { formik.handleChange(e); }} className={ formik.touched.confirm_month && formik.errors.confirm_month ? "form-control is-invalid" : "form-control" } > <option value="">---Select---</option> {monthlist} </Field> </OFMSUI.Col> <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" > <label> <b> Year</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span> <Field component="select" name="year" className={ formik.touched.year && formik.errors.year ? "form-control is-invalid" : "form-control" } onChange={(e) => { formik.handleChange(e); }} > <option value="">---Select---</option> {yearlist} </Field> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}> <th> District name: <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span> </th> <Field component="select" name="district" className={ formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control" } onChange={(e) => { formik.handleChange(e); }} > {formik.touched.district && formik.errors.district ? ( <div className="invalid-feedback"> {formik.errors.district} </div> ) : null} <option value="all">State</option> {distList} </Field> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}> <center> {" "} <button className="btn btn-primary btn-sm" type="submit" style={{ marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} > Submit </button> </center> </OFMSUI.Col>
            </OFMSUI.Row>
          </Form>
        </FormikProvider>

        {tableDataFlag && (
          <div style={{ overflow: "auto", height: "500px" }}>
            <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=" mb-2 float-end" >
              <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} > <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table" filename="DistWiseBankwisereport" sheet="tablexls" buttonText="Excel" ></ReactHTMLTableToExcel> </button> <button type="button" className="btn btn-danger btn-sm" onClick={GeneratePDF} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
            </OFMSUI.Col>
            <OFMSUI.Table striped bordered hover id="my-table">
              <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} > <tr> <td colSpan={7} style={{ textAlign: "center" }}> {DisplayDistrict}:Difference between the Calculated- {categoryValue}-Basic Pay and {categoryValue} -Paid for the {DistplayMonth} of {DisplayYear} </td> </tr>
                <tr className="table_countshead"> <th style={{ width: "5%" }}>S No.</th> <th style={{ width: "20%" }}>Employee Name</th> <th>Basic Pay</th> <th>Paid &nbsp; {categoryValue}</th> <th>Calculated </th> <th>Difference</th> <th>% of Paid &nbsp;{categoryValue}</th> </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => (
                  <tr key={index}> <td>{index + 1}</td> <td style={{ width: "140px" }} onClick={() => { handlePdf( item.emp_id, item.payment_type, item.year, item.confirm_month ); }} > <Link>{item.emp_name}</Link> </td> <td>{item.basic_pay_earnings}</td> <td>{item.round}</td> <td>{item.actual}</td> <td>{item.actual - item.round}</td> <td> {parseFloat( (item.round * 100) / item.basic_pay_earnings ).toFixed(2)} % </td> </tr>
                ))}
              </tbody>
            </OFMSUI.Table>
          </div>
        )}
      </OFMSUI.Container>
    </>
  );
};
export default VariationInCalculation;
